import React, { useState, useEffect, useRef } from 'react';
import { copyToClipboard } from '../utils/helpers';
import './SessionHeader.css';

function SessionHeader({
  sessionId,
  userCount,
  qrCode,
  openQRCodeInitially = false,
  onLeave,
}) {
  const [showQR, setShowQR] = useState(openQRCodeInitially);
  const [copied, setCopied] = useState(false);
  const prevUserCountRef = useRef(userCount);

  useEffect(() => {
    if (showQR && userCount > prevUserCountRef.current) {
      setShowQR(false);
    }
    prevUserCountRef.current = userCount;
  }, [userCount, showQR]);

  const handleCopyCode = async () => {
    const success = await copyToClipboard(sessionId);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="session-header">
      <div className="container">
        <div className="header-content">
          <div className="header-left">
            <h1 className="header-title">📁 Remote Transfer</h1>
            <div className="session-info">
              <div className="session-code-display">
                <span className="label">Session-Code:</span>
                <span className="code">{sessionId}</span>
                <button
                  className="btn-icon"
                  onClick={handleCopyCode}
                  title="Code kopieren"
                >
                  {copied ? '✓' : '📋'}
                </button>
                <button
                  className="btn-icon"
                  onClick={() => setShowQR(!showQR)}
                  title="QR-Code anzeigen"
                >
                  📱
                </button>
              </div>
              <div className="user-count">
                <span className="online-indicator"></span>
                {userCount} {userCount === 1 ? 'Nutzer' : 'Nutzer'} online
              </div>
            </div>
          </div>

          <div className="header-right">
            <button className="btn btn-danger" onClick={onLeave}>
              Session verlassen
            </button>
          </div>
        </div>

        {/* QR Code Modal */}
        {showQR && qrCode && (
          <div className="qr-modal">
            <div className="qr-content">
              <h3>Session-QR-Code</h3>
              <img src={qrCode} alt="Session QR Code" className="qr-image" />
              <p>Scanne diesen Code, um der Session beizutreten</p>
              <button className="btn btn-secondary" onClick={() => setShowQR(false)}>
                Schließen
              </button>
            </div>
          </div>
        )}

        {copied && (
          <div className="copy-notification">
            ✓ Code kopiert!
          </div>
        )}
      </div>
    </div>
  );
}

export default SessionHeader;
